import { z } from "zod";

import { machineAlarm } from "./machine-alarm";
import { machineStopReasonV2Schema } from "./machine-stop-reason-v2";

export const machineWorkstationSchema = z.object({
	number: z.number(),
	alarms: z.array(machineAlarm),
	warnings: z.array(machineAlarm),
	stopReason: machineStopReasonV2Schema,
});

export type Workstation = z.infer<typeof machineWorkstationSchema>;
